import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import AppSidebar from "../AppSidebar/AppSidebar"
import NotificationBell from "../NotificationBell/NotificationBell"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { NOTIFICATIONS_BELL } from "../../config/featureFlagKeys"
import { canSeeBell, storedRole } from "../../features/notifications/audience"

const ContainerPage = ({ children }) => {
  const bellFlagOn = useSelector(selectFeatureFlag(NOTIFICATIONS_BELL))
  const [role] = useState(storedRole)
  const showBell = bellFlagOn && canSeeBell(role)

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]')
    const original = viewport?.getAttribute('content')
    if (viewport) {
      viewport.setAttribute('content', 'width=1280')
    }
    return () => {
      if (viewport && original) {
        viewport.setAttribute('content', original)
      }
    }
  }, [])

  return (
    <div className='flex min-w-[1280px]'>
     <AppSidebar/>
     <div className='flex-1 min-w-0'>
       {showBell && (
         <header className="sticky top-0 z-10 h-16 bg-paper shadow-sm flex items-center justify-end px-10">
           <NotificationBell />
         </header>
       )}
       <div className="px-10 py-10">
           {children}
       </div>
     </div>
    </div>

  )
}
export default ContainerPage
